import { defaultApplicantName } from '../../../../../../../constants';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import PropertyCompanyRentRollRuleset from '../../business/ruleset/PropertyCompanyRentRollRuleset';
import loanFormModelNew from '../../form_models/loanFormModel';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';

const {
  companyDocuments: { propertyCompanyRentRoll },
  propertyCompanyUploadRentRollOrProvideTenantInfo,
} = loanFormModelNew.formField;

const { loanCategory } = loanFormModel.formField;
export class PropertyCompanyRentRollValidation implements ValidationSchema {
  public name = propertyCompanyRentRoll.name;
  public label = propertyCompanyRentRoll.getLabel(defaultApplicantName);
  public dependsOn: string[] = [
    propertyCompanyUploadRentRollOrProvideTenantInfo.name,
    loanCategory.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };

  public ruleset = PropertyCompanyRentRollRuleset;

  public when(...args: any[]) {
    const result: RulesetResult = args.pop();
    const required = !!(result & RulesetResult.REQUIRED);
    let schema = FileNameValidationSchema(
      propertyCompanyRentRoll.name,
      required
    );
    if (required) schema = schema.required('This document is required');
    return schema;
  }
}
export default new Validation(new PropertyCompanyRentRollValidation());
